<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar
        class="mt-4 custom-toolbar"
        elevation="0"
      >
        <v-text-field
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
      /></v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        :no-data-text="$t('messages.information.no_data')"
        :headers="headers"
        :items="actions"
        :search="search"
        item-text="text"
        :loading-text="$t('categories.nonconformity.action.loading')"
        :no-results-text="$tc('categories.nonconformity.action.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
        @dblclick:row="($event, { item }) => handleActionEdit(item)"
      >
        <template v-slot:item.end_date="{ item }">
          {{ toDatetime(item.end_date) }}
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end">
            <avs-editButton
              @click.stop="handleActionEdit(item)"
              :spantext="$t('actions.edit', { entity: $t('commons.action').toLowerCase() })"
            />
            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="$t('actions.delete', { entity: $t('commons.action').toLowerCase() })"
            />
          </div>
        </template>
      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="action"
      />
    </template>
  </avs-card>
</template>

<script>
import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"
import { NonConformityService, ProjectService } from "@/services"
import { toDatetime } from "@/utils/datetime"

export default {
  name: "AllActions",
  components: { Closed, Ongoing, Overdue, Pending },
  data() {
    return {
      deleteDialogIsOpen: false,
      headers: [
        { text: this.$t("categories.company.name"), value: "company.name", class: "min-width-150" },
        {
          text: this.$tc("categories.project.name", 1),
          value: "project.name",
          class: "min-width-150"
        },
        {
          text: this.$tc("categories.nonconformity.action.name", 1),
          value: "name",
          class: "min-width-200"
        },
        { text: this.$t("commons.date.end_date"), value: "end_date", class: "min-width-150" },
        { text: this.$t("commons.type"), align: "center", value: "type_action" },
        { text: this.$t("commons.cost") + " [€]", align: "center", value: "total_cost" },
        { text: this.$t("commons.status.name"), align: "center", value: "status" },
        { text: this.$t("commons.intended_for"), align: "center", value: "user" },
        {
          text: this.$t("commons.monitoring_intended_for"),
          align: "center",
          value: "monitoring_user"
        },
        {
          text: this.$t("commons.date.end_date"),
          value: "monitoring_end_date",
          class: "min-width-150"
        },
        {
          text: this.$t("commons.status.name"),
          value: "monitoring_status",
          class: "min-width-150"
        },
        {
          text: this.$t("commons.actions"),
          sortable: false,
          value: "actions",
          align: "right",
          width: 120
        }
      ],
      actions: [],
      loading: false,
      search: "",
      selectedItem: null
    }
  },
  created() {
    this.getAllActions()
  },
  methods: {
    getAllActions() {
      this.loading = true
      NonConformityService.getListAllActions().then(response => {
        this.actions = response
        this.loading = false
      })
    },
    async setStoreFromProjectId(projectId) {
      return ProjectService.get(this, null, projectId).then(project => {
        this.$store.commit("app/setCompany", project.company)
        this.$store.commit("app/setProject", project)
      })
    },
    async handleActionEdit(item) {
      const nonConformity = await NonConformityService.get(this, 0, item.non_conformity)
      this.setStoreFromProjectId(nonConformity.inspection.project).then(() => {
        this.$router.push({
          name: "NonConformityCreateUpdate",
          params: { id: item.non_conformity, tab: 4 }
        })
      })
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleStatusComponent(action) {
      return action.status
    },
    handleDelete(item) {
      NonConformityService.deleteAction(this.selectedItem.id).then(r => {
        this.actions = this.actions.filter(nc => nc.id !== this.selectedItem.id)
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$t("commons.action")
          }),
          color: "success"
        })
      })
      this.deleteDialogIsOpen = false
    },
    toDatetime
  }
}
</script>
